import Vue from 'vue';

Vue.filter('GetYear', function (value) {
  if (!value) return '';
  var reg = new RegExp('[-;/年]')
  if (reg.test(value)) {
    value = value.replace(/[-;/年]/g, "-");
    let newV = value.split('-');
    return newV[0] + '年';
  } else {
    return value + '年'
  }
  if (value.indexOf("-") >= 0) {
    let date = value.split("-");
    return date[0] + '年'
  }
  if (value.indexOf("年") >= 0) {
    let date = value.split('年')
    return date[0] + '年'
  }

});

Vue.filter('GetYearMonth', function (value) {
  if (!value) return "";
  var reg = new RegExp('[-;/.]');
  let valueObj = []
  if (reg.test(value)) {
    value = value.replace(/[-;/.]/g, '-');
  }
  try {
    valueObj = value.split("-");
    let yearMonth = valueObj[0] + '-' + valueObj[1]
    return yearMonth;
  } catch (err) { }

})

Vue.filter('GetDay', function (value) {
  if (!value) return "";
  var reg = new RegExp('[-;/.]');
  let valueObj = []
  if (reg.test(value)) {
    value = value.replace(/[-;/.]/g, '-');
  }
  try {
    valueObj = value.split("-");
    let day = valueObj[2] < 10 && valueObj[2].indexOf('0') === -1 ? '0' + valueObj[2] : valueObj[2];
    return day;
  } catch (err) { }
})

//将分隔字符写为、号
Vue.filter('formatStandardSep', function (value) {
  if (!value) return;
  var reg = new RegExp("[,;、.，/]");
  if (reg.test(value)) {
    value = value.replace(/[,;、.，/]/g, '、')
  }
  return value;
})

// 将日期转换为-格式
Vue.filter('formatStandardDate', function (value) {
  if (!value) return;
  var reg = new RegExp('[-;/]')
  if (reg.test(value)) {
    value = value.replace(/[-;/]/g, '-')
  }
  return value;
})


Vue.filter("formatShowFirst", function (value) {
  if (!value) return;
  var reg = new RegExp(',')
  if (reg.test(value)) {
    value = value.split(',')[0]
  }
  return value
})


Vue.filter("formatTime", function (num) {
  if (num == 0) {
    return "00:00"
  }
  if (!num) return
  let hh = parseInt(num / 3600)
  let mm = parseInt((num % 3600) / 60)
  let ss = ((num % 3600) % 60)
  if (hh <= 0) {
    return (mm < 10 ? '0' + mm : mm) + ':' + (ss < 10 ? '0' + ss : ss);

  }
  return (hh < 10 ? '0' + hh : hh) + ':' + (mm < 10 ? '0' + mm : mm) + ':' + (ss < 10 ? '0' + ss : ss);
})

Vue.filter("formatDate", function (dateStr, type) {
  let date = dateStr
  if (!date) return
  if (date.indexOf("T") >= 0) {
    date = date.replace("T", " ")
  }
  if (typeof (date) != 'number' && date.indexOf("-") >= 0) {
    date = new Date(date.replace(/-/g, "/"));
  } else {
    date = new Date(date);
  }
  if (date.toString() == 'Invalid Date') {
    return dateStr
  } else {
    // date = new Date(date) 
    let month = date.getMonth() + 1
    let day = date.getDate()
    let year = date.getFullYear()
    if (type == 'month') {
      return month
    }
    if (type == 'day') {
      return day
    }
    if (type == 'year') {
      return year
    }
    let nd = day < 10 ? '0' + day : day
    let nm = month < 10 ? '0' + month : month
    if (type == 'day/month') {
      return nd + "/" + nm
    }
    if (type == "yymmdd") {
      return year + "-" + nm + "-" + nd
    }
    if (type == '年月') {
      return year + '年' + nm + '月'
    }
    if (type == '年月日') {
      return year + '年' + nm + '月' + nd + '日'
    }
  }
})